import angular from 'angular';

import RwRatailerInfoComponent from './rw-retailer-info-component';

export default angular
  .module('rw-retailer-info', ['rw-retailer-id'])
  .component('rwRetailerInfo', new RwRatailerInfoComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-retailer-info/rw-retailer-info-module.js